"use client"

import { HttpTypes } from "@medusajs/types"
import { useParams } from "next/navigation"

// "Enviar a <pais>" block. The country is the one in the URL, which drives the
// region, currency and the Packlink destination.
const DeliverTo = ({ regions }: { regions: HttpTypes.StoreRegion[] | null }) => {
  const { countryCode } = useParams() as { countryCode: string }
  const country = regions
    ?.flatMap((r) => r.countries ?? [])
    .find((c) => c?.iso_2 === countryCode)

  let name = country?.display_name ?? countryCode?.toUpperCase()
  try {
    name = new Intl.DisplayNames(["es"], { type: "region" }).of(countryCode.toUpperCase()) ?? name
  } catch {
    // Keep the region's own display name.
  }

  return (
    <div className="amz-nav-item hidden medium:flex items-end gap-x-1 shrink-0">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="mb-1">
        <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" />
        <circle cx="12" cy="9.5" r="2.5" />
      </svg>
      <div>
        <span className="block text-xs text-[#ccc]">Enviar a</span>
        <span className="block text-sm font-bold">{name}</span>
      </div>
    </div>
  )
}

export default DeliverTo
